
import { mapMutations } from 'vuex'

const garbage = {
  beforeRouteLeave (to, from, next) {
    // pause app
    this.$refs.background.getApp().stop()

    // add pixi app to garbage collector
    this.addPixiApp(this.$refs.background.getApp())
    next()
  },
  methods: {
    ...mapMutations('animations', [
      'addPixiApp'
    ])
  }
}

export default garbage
